import './index.scss'
import { ethers } from "ethers";
import polygon from '@/static/images/polygon.png'
import ClearDiv from '@/components/clearDiv';
import { Button } from 'react-bootstrap';
import StoryCard from './components/storyCard';
import Image from 'react-bootstrap/Image'
import { useNavigate } from 'react-router-dom';
import { getBookList, getBookListByUser, updateBook, genSBNChainInfo, getBookWeb3SBNInfo } from '@/data';
import { useEffect, useState } from 'react';
import DzPop from '@/components/dzPop';
import FormInput from '@/components/formInput';
import { useDispatch } from 'react-redux';
import { setLoadingCoverStatus } from '@/store';
import Web3SBNPRC20 from '@/abi/Web3SBNPRC20.json'
import SixteenDao from '@/abi/SixteenDao.json';
import { useSelector } from 'react-redux';
import { numFormat } from '@/utils';
import { createAlert } from "@/components/dzAlert";
import bigInt from 'big-integer';
import {
    abiAddress,
    hashSBN,
    SBNAddress
} from '@/abi/address';
function MyStory() {
    const jumpTo = useNavigate()
    const dispatch = useDispatch()
    const { address } = useSelector(state => state.home)
    const [bookList, setBookList] = useState([])

    async function updateBookList() {
        dispatch(setLoadingCoverStatus(true))
        const res = await getBookListByUser({
            "limit": 200,
            "offset": 0,
            "title": ""
        })
        dispatch(setLoadingCoverStatus(false))
        if (res?.data) {
            setBookList((res.data || [])
                // .map(book => {
                //     if (book.id === 10127) {

                //         return {
                //             ...book,
                //             status: 4,
                //         }
                //     }
                //     return book
                // })
            )
        }
    }

    async function updateBookInfo(bookInfo) {
        bookInfo.status = 3
        const res = await updateBook(bookInfo)
        updateBookList()
    }


    const [SBNShow, setSBNShow] = useState(false);
    const closeSBNPop = () => {
        setSBNShow(false);
        setBookSBNInfo({
            "SBN": '',
            "total_supply": 0,
            "limit_per_mint": 0,
            "selling_price": 0,
            "book_id": '',
        });
    }
    const openSBNDeployPop = async (book) => {
        console.log('book: ', book);
        // const res = await getSBNChainInfo(book.id);
        // console.log('res: ', res);
        setBookSBNInfo({
            ...bookSBNInfo,
            "book_id": book.id,
        })
        setSBNShow(true);
    }
    const deploySBN = () => {
        console.log('bookSBNInfo: ', bookSBNInfo);
        genSBNChainInfoHandler()
        // closeSBNPop();
    }
    const genSBNChainInfoHandler = async () => {
        const res = await genSBNChainInfo({
            "book_id": bookSBNInfo.book_id,
            "total_supply": bookSBNInfo.total_supply,
            "limit_per_mint": bookSBNInfo.limit_per_mint,
            "selling_price": bookSBNInfo.selling_price,
        })
        console.log('genSBNChainInfo res: ', res);
        if (res?.code === 0 && res?.data) {
            const { web3_sbn, carbon_sink_per_copy, limit_per_mint, selling_price, total_supply } = res.data;
            inscribeAuthorCopyright({
                _web3SBN: web3_sbn,
                _carbonSinkPerCopy: carbon_sink_per_copy,
                _limitPerMint: limit_per_mint,
                _sellingPrice: selling_price,
                _totalSupply: total_supply,
                // _metadataHash,
                // _licenseTerms,
            })
        }
    }
    const [SBNInfoShow, setSBNInfoShow] = useState(false);
    const closeSBNInfoPop = () => {
        setSBNInfoShow(false);
    }
    const [bookRecord, setBookRecord] = useState({});
    const openSBNInfoPop = async (record) => {
        setBookRecord(record);
        setSBNInfoShow(true);
    }
    useEffect(() => {
        updateBookList()
    }, [])
    const getBookWeb3SBN = async (bookId) => {
        const { data: { web3_sbn = '' } } = await getBookWeb3SBNInfo({ book_id: bookId }).catch(err => {
            return { data: { web3_sbn: '' } };
        });
        return web3_sbn

    }
    const checkSBN = async (address, book) => {
        const sbn = await getBookWeb3SBN(book.id)
        if (!sbn) {
            openSBNDeployPop(book)
            return;
        }
        console.log('sbn:', sbn)
        const SBNhash = hashSBN(sbn)
        console.log('SBNhash:', SBNhash)
        const record = await getSBNContact(SBNhash)
        if (record.isAuthorInscribed) {
            openSBNInfoPop(record)
        }
        else {
            openSBNDeployPop(book)
        }
    }
    const getGasPrice = async () => {
        const baseGasPrice = await window.web3.eth.getGasPrice()
        console.log('baseGasPrice:', baseGasPrice)
        const price = window.web3.utils.fromWei(baseGasPrice, 'gwei');
        console.log('price:', price)
        return Math.ceil(price * 1.1);
    }
    const getSBNContact = async (SBNhash) => {
        // await preIncrebe()
        const record = await getRecord(SBNhash)
        console.log('record:', record)
        return record;
        // const res = await mintUserCopyright(SBNhash, address, 1, 385);
        // console.log('mintUserCopyright res:', res)
    }
    const preIncrebe = async () => {

        const SBNabi = Web3SBNPRC20.abi;
        const abi = SixteenDao.abi;
        window.SBNContract = new window.web3.eth.Contract(SBNabi, SBNAddress)
        window.contract = new window.web3.eth.Contract(abi, abiAddress)

        // 1. 用户连接 MetaMask
        const provider = new ethers.BrowserProvider(window.ethereum);
        const signer = await provider.getSigner(); // 当前连接的钱包地址


        const token = new ethers.Contract(abiAddress, abi, signer);
        const allowance = await token.allowance(address, SBNAddress);
        console.log("当前授权额度:", ethers.formatUnits(allowance, 18));
        if (allowance <= 0) {
            const bal = await window.contract.methods.balanceOf(address).call()
            // const balance = parseInt(bal/1000000000000000000)
            console.log('bal:', bal)

            // 3. 调用 approve 授权
            const amount = ethers.parseUnits(bal, 18); // 授权 1000 个代币（注意小数位数）
            const tx = await token.approve(SBNAddress, amount);
            console.log("授权交易发送中，TxHash:", tx.hash);
        }

    }
    const getRecord = async (hash) => {
        console.log('sbn hash:', hash)
        let result = await window.SBNContract.methods.getRecord(hash)
            .call()
        console.log('getRecord:', result)
        return result;
    }
    const inscribeAuthorCopyright = async ({
        _web3SBN,
        _metadataHash = '',
        _licenseTerms = '',
        _totalSupply,
        _limitPerMint,
        _sellingPrice,
        _carbonSinkPerCopy
    }) => {
        try {
            await preIncrebe();
            const inscribeAuthorCopyright = await window.SBNContract.methods.inscribeAuthorCopyright(
                _web3SBN,
                _metadataHash,
                _licenseTerms,
                _totalSupply,
                _limitPerMint,
                _sellingPrice,
                _carbonSinkPerCopy
            )
            const gasBase = await inscribeAuthorCopyright.estimateGas({ from: address });
            console.log('当前需要的 gas:', gasBase);
            const gasPrice = gasBase * 352500
            console.log('当前需要的 gas增幅:', gasPrice);
            const result = inscribeAuthorCopyright.send({
                from: address,
                gasPrice,
            });
            console.log('inscribeAuthorCopyright result:', result);
            if (result && result.status) {
                setSBNInfoShow(false);
                createAlert({ type: 'success', content: 'Inscribe Author Copyright Success!' })
            }
        } catch (err) {
            console.error('inscribeAuthorCopyright error:', err);
            if (err && err.message) {
                alert('inscribeAuthorCopyright error: ' + err.message);
            }
            throw err;
        }
    }
    const mintUserCopyright = async (web3SBNHash, address, amount, carbonSinkAmount) => {
        try {
            let result = await window.SBNContract.methods.mintUserCopyright(web3SBNHash, address, amount, carbonSinkAmount)
                .send({
                    from: address
                });
            return result;
        } catch (err) {
            console.error('mintUserCopyright error:', err);
            if (err && err.message) {
                alert('mintUserCopyright error: ' + err.message);
            }
            throw err;
        }
    }
    const getData = async (address) => {
        let result = await window.SBNContract.methods.MAX_TOTAL_SUPPLY().call();
        console.log('getData:', result)
        return result;
    }
    const creatorRecords = async (address) => {
        let result = await window.SBNContract.methods.creatorRecords(address).call();
        console.log('records:', result)
        return result;
    }
    const records = async (address) => {
        let result = await window.SBNContract.methods.records(SBNAddress).call();
        console.log('records:', result)
        return result;
    }
    const getBalance = async (address) => {
        let result = await window.SBNContract.methods.balanceOfInscription(SBNAddress, address).call();
        return result;
    }
    const getUserCarbonSink = async (address) => {

        let result = await window.SBNContract.methods.getUserCarbonSink(SBNAddress, address).call();
        return result;
    }

    const [bookSBNInfo, setBookSBNInfo] = useState({
        "SBN": '',
        "total_supply": 0,
        "limit_per_mint": 0,
        "selling_price": 0,
        "book_id": '',
    });
    const mockBooks = [
        // {
        //     "id": 10123,
        //     "status": 4,
        //     "deploy": 1,
        //     "email": "qwe@qq.com",
        //     "title": "helloo",
        //     "author_name": "qwe",
        //     "author_profile": "qwerrrrrr",
        //     "description": "qqqqqqqqqqqqqq",
        //     "image_url": "https://16dao.xyz/api/static/2d667207-218e-48ca-ae45-894eb0ea530f.png"
        // }, {
        //     "id": 101214,
        //     "status": 4,
        //     "email": "qwe@qq.com",
        //     "title": "helloo",
        //     "author_name": "qwe",
        //     "author_profile": "qwerrrrrr",
        //     "description": "qqqqqqqqqqqqqq",
        //     "image_url": "https://16dao.xyz/api/static/2d667207-218e-48ca-ae45-894eb0ea530f.png"
        // }
    ]
    const checkOnPolygon = () => {
        const url = `https://polygonscan.com/address/${SBNAddress}`;
        window.open(url, '_blank');
    }
    return (
        <div className='container my-story'>
            <ClearDiv>
                <div className='my-story-container'>

                    <div className='my-story-title'>Web3SBN Inscribe</div>
                    <div className='tips'>Web3SBN Inscribe is the first global Web3 standard book number protocol issued by DZ Labs; it provides novelists and digital artists with new Web3 copyright transactions and copyright preservation capabilities, and provides users with the ability to buy and sell inscription digital copyrights. While creating 16DAO payment application scenarios, it also provides crypto-financial mortgage and loan services for inscription holders on this platform.</div>
                    <div className='tips'>After the novel is approved, the issuer can apply for Web3SBN and mint the electronic novel (i.e. inscription). When the inscription is sold for the first time, the issuer can get 90% of the income. When the inscription is traded for a second time, the issuer can get 10%. income.</div>
                    <div className='devide'></div>
                    <div className='my-story-title'>Request for publishing novels</div>
                    <div className='tips'>Anyone can publish novels, but in order to ensure the rights of the copyright owner, publishers are required to submit introduction materials to <a className='link-tag'>dzlabs2022@gmail.com</a> first, whether it is a publishing house, the author himself, or a copyright agent, the email title must be consistent for "Novel Release Application", our Sub DAO operating members will respond as soon as possible.
                        Only those whose applications are approved will have their published novels displayed on the official website and receive copyright trading income.</div>
                    <div className='devide'></div>
                    <div className='my-story-title'>My Stories</div>
                    <div className='tips'>Tips: After novel is approved, platform will contact publisher to sign a contract. Then novels cannot be modified and users can start reading.</div>
                    <div className='btns-group flex-row'>
                        <Button variant="outline-secondary" className='about-btn'>About writers</Button>
                        <Button className='create-btn' onClick={e => jumpTo('/storyinfo')}>Create+</Button>
                    </div>
                    <div className='my-story-list flex-row-space-between flex-row-wrap'>
                        {[...mockBooks, ...bookList].map(book =>
                            <StoryCard
                                book={book}
                                key={book.id}
                                onEditClick={e => jumpTo(`/storyinfo?bookId=${book.id}`)}
                                onChapterClick={e => jumpTo(`/volume?bookId=${book.id}`)}
                                onEndClick={e => updateBookInfo(book)}
                                openSBNPop={e => checkSBN(address, book)}
                            />)
                        }
                    </div>
                </div>
            </ClearDiv>

            <DzPop popShow={SBNShow} closeClick={e => closeSBNPop()} mask>
                <div className='sbn-form'>
                    <div className='pop-title'> Deploy Web3SBN inscriptions</div>
                    <FormInput label={'Protocol'} dark  >
                        <div style={{ width: '100%' }} className='flex-row'>
                            <div className='protocol-tag'>prc-20</div>
                            <Image src={polygon} width={100} className='polygon-logo' />
                        </div>
                    </FormInput>
                    <FormInput label={'Web3SBN'} dark defaultValue={bookSBNInfo.SBN} placeholder={'Name'} maxLength={50} onInput={e => setBookSBNInfo({ ...bookSBNInfo, SBN: e })}></FormInput>
                    <FormInput label={''} dark style={{ marginTop: '-14px' }}>
                        <div style={{ width: '100%' }} className='flex-row'>It is recommended to fill in the first letter of the novel title. If it has already been used by someone else, it is recommended to add the first letter of the author's name or a meaningful number after it.</div>
                    </FormInput>
                    <FormInput label={'Total Supply'} dark defaultValue={bookSBNInfo.total_supply} placeholder={'Input a number，1~16,000'} maxLength={50} max={16000} min={1} onInput={e => setBookSBNInfo({ ...bookSBNInfo, total_supply: e })}></FormInput>
                    <FormInput label={'Limit Per Mint'} dark defaultValue={bookSBNInfo.limit_per_mint} placeholder={'Input a number，1~100'} maxLength={50} max={100} min={1} onInput={e => setBookSBNInfo({ ...bookSBNInfo, limit_per_mint: e })}></FormInput>
                    <FormInput label={'Selling Price'} dark defaultValue={bookSBNInfo.selling_price} placeholder={'/Copy, 00 $16DAO'} maxLength={50} max={Number.MAX_SAFE_INTEGER} min={0} onInput={e => setBookSBNInfo({ ...bookSBNInfo, selling_price: e })}></FormInput>
                    <Button className='pop-btn' onClick={e => deploySBN()}>Deploy</Button>
                </div>
            </DzPop>

            <DzPop popShow={SBNInfoShow} closeClick={e => closeSBNInfoPop()} mask>
                <div className='sbn-form'>
                    <div className='pop-title'> Web3SBN inscriptions</div>
                    <div className='sbn-row flex-row'>
                        <div className='label'>Web3SBN</div>
                        <div className='text' title={bookRecord.web3SBNHash}>{bookRecord.web3SBNHash}</div>
                    </div>
                    <div className='sbn-row flex-row'>
                        <div className='label'>Total Supply</div>
                        <div className='text' title={numFormat(bookRecord.totalSupply)}>{numFormat(bookRecord.totalSupply)}</div>
                    </div>
                    <div className='sbn-row flex-row'>
                        <div className='label'>Limit Per Mint</div>
                        <div className='text' title={numFormat(bookRecord.limitPerMint)}>{numFormat(bookRecord.limitPerMint)}</div>
                    </div>
                    <div className='sbn-row flex-row'>
                        <div className='label'>Carbon Sink/Copy</div>
                        <div className='text' title={`${numFormat(bookRecord.carbonSinkPerCopy)}g`}>{`${numFormat(bookRecord.carbonSinkPerCopy)}g`}</div>
                    </div>
                    <div className='sbn-row flex-row'>
                        <div className='label'>Selling Price/Copy</div>
                        <div className='text' title={`${numFormat(bookRecord.sellingPrice)} $16DAO`}>{`${numFormat(bookRecord.sellingPrice)} $16DAO`}</div>
                    </div>
                    <Button className='pop-btn' onClick={e => checkOnPolygon()}>Check on polygonscan</Button>
                </div>
            </DzPop>
        </div>
    )
}
export default MyStory;